import React, { useState } from "react";
import { FaShieldAlt, FaUserShield, FaLock, FaMinus, FaPlus, FaHeadset, FaExclamationTriangle, FaUserMd, FaUserCheck, FaUsers, FaClipboardList, FaChalkboardTeacher, FaFileAlt, FaSearch, FaCog,} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Component/Fooder";
import { motion } from 'framer-motion';
import Healthcare from "../../../assests/service/Healthcare.jpg";

const Hiippa = () => {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            <div className="w-full bg-gray-50">
                {/* Hero Section */}
                <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-2"
                    style={{ backgroundImage: `url(${Healthcare})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">HIPAA Compliance & Security Consulting</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            At HIKEHEALTH Gs, We provide HIPAA Compliance & Security Consulting services, including risk assessments, security audits, and staff training, ensuring healthcare organizations meet HIPAA, HITECH, and GDPR standards while protecting patient data.
                        </p>
                        <button
                            className="mt-3 px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition"
                            onClick={() => navigate("/Contact")}
                        >
                            LET’S DISCUSS YOUR NEEDS
                        </button>
                    </motion.div>
                </div>

                <div className="bg-white max-w-full mx-auto py-16 px-6">                {/* How We Can Help Section */}
                    <section className="w-full  mx-auto  px-2">
                        <h2 className="text-[30px] font-bold text-center flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">How We Can Help</h2>
                        <p className="text-gray-800 text-center text-sm mt-2">
                            Exchanging healthcare data is critical, but it can be complex. We simplify the process, ensuring smooth integration.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto px-4 mt-4">
                            {helpFeatures.map((feature, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <feature.icon className="text-[#2a627a] text-4xl mx-auto mb-4" />
                                    <h3 className="text-lg text-[#2a627a] font-bold">{feature.title}</h3>
                                    <p className="text-gray-800 text-sm mt-2">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Key Interoperability Services */}
                    <section className=" py-12">
                        <div className="w-full mx-auto  ">
                            <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">Key Services</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                                {services.map((service, index) => (
                                    <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                        initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                        viewport={{ once: false, amount: 0.3 }}>
                                        <h3 className="text-lg font-bold text-[#2a627a]">{service.title}</h3>
                                        <p className="text-gray-800 text-sm mt-2">{service.description}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>
                    {/* Why Choose Us */}
                    <section className="w-full mx-auto ">
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Why Choose Us?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-6 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                    whileInView={{ opacity: 1, x: 0 }} // Move to center
                                    transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <h3 className="text-lg font-bold text-[#2a627a]">{item.title}</h3>
                                    <p className="text-gray-800  text-sm mt-2">{item.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="mt-12 w-full  mx-auto">
                        {/* Heading */}
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                            Discover Our Services
                        </h2>

                        {/* Service List */}
                        <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                            {List.map((service, index) => (
                                <div key={index} className="border-b border-gray-800">
                                    {/* Service Title */}
                                    <button
                                        className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                    >
                                        {service.title}
                                        {openIndex === index ? (
                                            <FaMinus className="text-red-500" />
                                        ) : (
                                            <FaPlus className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Service Description (Expandable with Animation) */}
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                        className="overflow-hidden"
                                    >
                                        <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                    </motion.div>
                                </div>
                            ))}
                        </div>
                    </section>



                </div>
                {/* Contact Section */}
                <div className="w-full bg-[#2a627a] text-white py-12 text-center">
                    <h2 className="text-2xl font-bold">Ready to Transform Healthcare?</h2>
                    <p className="mt-2">Let’s collaborate to build seamless and secure healthcare solutions.</p>
                    <button
                        className="mt-4 px-6 py-3 bg-white text-[#2a627a] font-semibold rounded-lg hover:bg-gray-400 transition"
                        onClick={() => navigate("/Contact")}
                    >
                        Book Your Free Consultation
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

// Data for different sections
const helpFeatures = [
    {
        title: "HIPAA Compliance Strategy",
        description: "Comprehensive compliance strategies to meet HIPAA, HITECH, and GDPR requirements.",
        icon: FaShieldAlt
    },
    {
        title: "Risk Assessments & Audits",
        description: "Identify vulnerabilities, assess risks, and implement corrective actions.",
        icon: FaClipboardList
    },
    {
        title: "Data Security & Encryption",
        description: "Protect sensitive patient information with end-to-end encryption and access control.",
        icon: FaLock
    },
    {
        title: "Staff Training & Awareness",
        description: "Educate employees on HIPAA regulations and best practices for data security.",
        icon: FaUsers
    },
    {
        title: "Ongoing Compliance Monitoring",
        description: "Ensure continuous adherence to regulatory standards with periodic audits and reporting.",
        icon: FaUserCheck
    }
];



const services = [

    {
        title: "HIPAA Compliance Assessment",
        description: "Evaluate your current security posture, workflows, and data management practices.",
        icon: FaShieldAlt
    },
    {
        title: "Security Risk Analysis",
        description: "Identify vulnerabilities in EHR systems, databases, APIs, and network infrastructure.",
        icon: FaSearch
    },
    {
        title: "Policy & Documentation Development",
        description: "Create HIPAA-compliant privacy policies, data retention strategies, and employee guidelines.",
        icon: FaFileAlt
    },
    {
        title: "Technical Safeguards Implementation",
        description: "Deploy data encryption, role-based access control (RBAC), and multi-factor authentication (MFA).",
        icon: FaLock
    },
    {
        title: "Security Training & Awareness",
        description: "Educate staff on PHI handling, data security best practices, and compliance requirements.",
        icon: FaChalkboardTeacher
    },
    {
        title: "Incident Response & Breach Management",
        description: "Establish protocols for breach detection, reporting, and mitigation.",
        icon: FaExclamationTriangle
    },
    {
        title: "Third-Party Vendor Compliance Audits",
        description: "Ensure cloud providers, SaaS platforms, and business associates meet HIPAA requirements.",
        icon: FaUserShield
    }
];

const whyChooseUs = [
    {
        title: "Expertise in Healthcare Security",
        description: "Our team specializes in HIPAA, HITECH, GDPR, and SOC 2 compliance.",
        icon: FaUserMd
    },
    {
        title: "End-to-End Compliance Solutions",
        description: "From risk assessments to policy implementation, we cover all aspects of security.",
        icon: FaShieldAlt
    },
    {
        title: "Proactive Threat Detection",
        description: "We leverage AI-powered security tools for real-time monitoring and threat prevention.",
        icon: FaSearch
    },
    {
        title: "Custom Compliance Strategies",
        description: "Tailored solutions for hospitals, clinics, health tech startups, and enterprise platforms.",
        icon: FaCog
    },
    {
        title: "Continuous Monitoring & Support",
        description: "Stay compliant with regular audits, updates, and 24/7 security support.",
        icon: FaHeadset
    }
];

const List = [
    
        {
            "title": "Full HIPAA Compliance Audit",
            "description": "Conduct a comprehensive assessment of your administrative, physical, and technical safeguards to ensure full HIPAA compliance. Our audit process identifies potential vulnerabilities, evaluates policies and procedures, and provides actionable recommendations to strengthen data security and regulatory adherence.",
            "icon": "FaShieldAlt"
        },
        {
            "title": "Data Encryption & Access Control",
            "description": "Implement end-to-end encryption for data in transit and at rest, ensuring the highest level of security for Protected Health Information (PHI). Our solutions include role-based access controls (RBAC), multi-factor authentication (MFA), and audit logging to safeguard sensitive healthcare data from unauthorized access.",
            "icon": "FaLock"
        },
        {
            "title": "Cloud & SaaS Compliance Consulting",
            "description": "Ensure your cloud infrastructure and SaaS applications meet HIPAA standards with expert consulting for AWS, Azure, Google Cloud, and other platforms. We help implement necessary safeguards, including encryption, data retention policies, and secure API integrations to maintain compliance and data integrity.",
            "icon": "FaCloud"
        },
        {
            "title": "Business Associate Agreement (BAA) Review",
            "description": "Evaluate and ensure compliance with Business Associate Agreements (BAAs) for third-party vendors handling Protected Health Information (PHI). We review contracts, assess vendor security practices, and provide recommendations to mitigate risk and maintain regulatory compliance.",
            "icon": "FaFileContract"
        },
        {
            "title": "Security Framework Implementation",
            "description": "Align your organization with industry-leading security frameworks, including NIST, ISO 27001, and SOC 2. We develop and implement policies, conduct risk assessments, and establish security controls to strengthen compliance, improve operational resilience, and safeguard patient data.",
            "icon": "FaCogs"
        }
    ]
    



export default Hiippa;
